var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(-366 -551)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_35",
    "data-name": "Rect\\xE1ngulo 35",
    width: 18,
    height: 18,
    transform: "translate(366 551)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chair-2",
    transform: "translate(363.976 552.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M14.456,8.848H9.167L8.506,1.495S8.121.023,11.811.023s3.308,1.472,3.308,1.472l-.662,7.353Z",
    transform: "translate(-0.598 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M15.928,15.189a.741.741,0,0,1-.7.836H7.8a.742.742,0,0,1-.7-.836s.51-2.441,1.509-2.441h5.633c1.139,0,1.685,2.441,1.685,2.441Z",
    transform: "translate(-0.302 -2.703)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40",
    "data-name": "Trazado 40",
    d: "M19.443,9.559c0,.439-.237.528-.529.528s-.529-.089-.529-.528V6.2c0-.44.237-.5.529-.5s.529.065.529.5Z",
    transform: "translate(-2.699 -1.204)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M6.738,9.559c0,.439-.237.528-.529.528S5.68,10,5.68,9.559V6.2c0-.44.237-.5.529-.5s.529.065.529.5Z",
    transform: "translate(0 -1.204)",
    fill: "#707070",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.07c6f628c889927deec1288bfb2619b9.svg";
export { ForwardRef as ReactComponent };